import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["media", "button"];

  connect() {
    this.sync();
  }

  toggle() {
    if (!this.hasMediaTarget) return;
    this.mediaTarget.muted = !this.mediaTarget.muted;
    this.sync();
  }

  sync() {
    if (!this.hasButtonTarget || !this.hasMediaTarget) return;
    const muted = !!this.mediaTarget.muted;
    this.buttonTarget.textContent = muted ? "🔇" : "🔊";
    this.buttonTarget.setAttribute("aria-pressed", muted ? "true" : "false");
    this.buttonTarget.setAttribute("aria-label", muted ? "unmute spotlight ad" : "mute spotlight ad");
  }
}
